import { useFocusScopeBranch } from "@radix-ui/react-focus-scope";
import { useLayoutEffect, useRef, useSyncExternalStore } from "react";

import { externalOverlayIsOpen, subscribeToExternalOverlay } from "@/lib/external-overlay";

/**
 * Google owns focus while its body-level chooser is open. Register that part
 * of the document through Radix's branch API, without remounting the editor or
 * swallowing the focus events Google also needs. The modal's pointer lock
 * still protects the page behind the chooser.
 */
export function ExternalOverlayBranch() {
  const open = useSyncExternalStore(subscribeToExternalOverlay, externalOverlayIsOpen, () => false);
  const anchor = useRef<HTMLSpanElement>(null);
  const wasOpen = useRef(false);
  useFocusScopeBranch(open ? document.body : null);
  useLayoutEffect(() => {
    const content = anchor.current?.closest<HTMLElement>('[role="dialog"]');
    // Radix remembers the last focused branch node. Seed it with the editor
    // again before removing the branch, or it can keep focusing a dead iframe.
    if (wasOpen.current && !open && content && !content.contains(document.activeElement)) {
      content.focus({ preventScroll: true });
    }
    wasOpen.current = open;
  }, [open]);
  return <span ref={anchor} hidden />;
}
